import { apiFetch } from './auth';

export function getAllStats() {
  return apiFetch('/stats');
}

export function getTruckStats(truckId) {
  return apiFetch('/stats/' + truckId);
}

// Fleet GPS coverage heatmap. days defaults server-side to 30 and is capped
// at 90. Returns { days, point_count, points: [[lat, lng, weight], ...] }.
export function getCoverageHeatmap(days = 30) {
  return apiFetch('/reports/heatmap?days=' + days);
}

// CO2 / ESG monthly report. year + month default to the current calendar
// month server-side. Returns fleet totals, per-truck breakdown, 6-month trend
// and the carbon price the org has configured.
export function getCo2Report(year, month) {
  const params = new URLSearchParams();
  if (year) params.set('year', String(year));
  if (month) params.set('month', String(month));
  const qs = params.toString();
  return apiFetch('/reports/co2' + (qs ? '?' + qs : ''));
}

// Streamed PDF download (auth header required, so we fetch + blob ourselves).
export async function downloadCo2ReportPdf(year, month) {
  const params = new URLSearchParams();
  if (year) params.set('year', String(year));
  if (month) params.set('month', String(month));
  const qs = params.toString();
  const base = (import.meta.env.VITE_API_URL || '/api') + '/reports/co2/pdf' + (qs ? '?' + qs : '');
  const token = localStorage.getItem('tg_token');
  const res = await fetch(base, { headers: { Authorization: 'Bearer ' + token } });
  if (!res.ok) throw new Error('Failed to download report (' + res.status + ')');
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `tankguard-co2-${year}-${String(month).padStart(2, '0')}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}
